export default __webpack_public_path__ + "assets/001b2ec6a10d9124fe5585fce2354551.png";